import { ComandaSplit } from '@/enums/ComandaSplit';

/**
 * «Impresión» of the editors (plan §5.12): the stations a product prints
 * on, and how its comanda is split. The two switches map to `comandaSplit`
 * as `NewItemModal.vue` does: off → none; on → unit; on + group → line.
 */

/** Adds or removes a station keeping the stored order (a no-op round trip stays clean). */
export function toggleStation(
  ids: readonly number[],
  stationId: number
): number[] {
  return ids.includes(stationId)
    ? ids.filter((id) => id !== stationId)
    : [...ids, stationId];
}

/** «Barra, Cocina»; empty for no station. */
export function stationList(
  ids: readonly number[] | null,
  name: (stationId: number) => string
): string {
  return (ids ?? []).map(name).join(', ');
}

/** «Imprimir aparte del resto del pedido». */
export function printsApart(split: ComandaSplit): boolean {
  return split !== ComandaSplit.None;
}

/** «Agrupar las unidades iguales en una misma comanda». */
export function groupsIdentical(split: ComandaSplit): boolean {
  return split === ComandaSplit.Line;
}

export function splitFromSwitches(
  apart: boolean,
  group: boolean
): ComandaSplit {
  if (!apart) return ComandaSplit.None;
  return group ? ComandaSplit.Line : ComandaSplit.Unit;
}
